/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProductIdentifier = 'PROTECT' | 'STORAGE' | 'CSP';

export const ProductIdentifier = {

    PROTECT: 'PROTECT' as ProductIdentifier,

    STORAGE: 'STORAGE' as ProductIdentifier,

    CSP: 'CSP' as ProductIdentifier
};

